import type { Action } from './actions'
import type {
    KingdomPoints,
    MarketingAnimationsData,
    MetaShortDTO,
    NearbyRestaurantsDTO
} from 'shared/types'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export const emptyMarketingAnimation = {
    actionColor: '',
    actionLabel: '',
    actionUrl: '',
    appRoute: '',
    displayOrder: 0,
    external: false,
    htmlContent: '',
    imageTitle: '',
    imageUrlApp: [],
    imageUrlCropped: [],
    imageUrlLandscape: [],
    imageUrlPortrait: [],
    enableVideo: false,
    audio: false,
    autoPlay: false,
    repeat: false,
    videoUrlApp: '',
    videoUrlLandscape: '',
    videoUrlPortrait: '',
    title: '',
    subtitle: ''
}

export type State = {
    marketingAnimations?: MarketingAnimationsData,
    metaData: MetaShortDTO,
    nearbyRestaurants?: NearbyRestaurantsDTO,
    pointInfos?: KingdomPoints,
    marketingFirst?: boolean,
    maxDisplay: number,
    error?: any,
    networkError?: any,
    dataLoaded?: boolean
}

const initialState: State = {
    metaData: {
        canonicalURL: '',
        keywords: '',
        seoDescription: '',
        title: ''
    },
    marketingAnimations: {
        primary: [],
        suggestions: {
            routeId: '',
            title: '',
            products: []
        },
        footerNotice: emptyMarketingAnimation,
        widget: emptyMarketingAnimation
    },
    nearbyRestaurants: {
        furthest: 0,
        number: 0
    },
    maxDisplay: 4,
    dataLoaded: false
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_ROOT_RESPONSE':
            const homePage = action.data?.homePage
            return {
                ...state,
                ...homePage,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'PAGE_DATA_HOMEPAGE_RESPONSE':
            const { analyticsData, ...homeState } = action.data
            return {
                ...state,
                ...homeState,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'HOMEPAGE_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.pages.home)
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
